/**
 * @generated SignedSource<<63d7f02eb8ec2935fa220cae6c3ba79b>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type UserAvatar_user$fragmentType: FragmentType;
export type UserAvatar_user$data = {|
  +avatar: {|
    +url: string,
  |},
  +name: string,
  +$fragmentType: UserAvatar_user$fragmentType,
|};
export type UserAvatar_user$key = {
  +$data?: UserAvatar_user$data,
  +$fragmentSpreads: UserAvatar_user$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserAvatar_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Avatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node/*: any*/).hash = "faa7646b89482552ae84f61ad658d84f";

module.exports = ((node/*: any*/)/*: Fragment<
  UserAvatar_user$fragmentType,
  UserAvatar_user$data,
>*/);
